import styled from 'styled-components';
import React, { ButtonHTMLAttributes, ImgHTMLAttributes } from 'react';

import { components } from '~/assets';

export const Container = styled.header`
  position: relative;
  padding: 24px 16px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  font-size: ${({ theme: { fontSizes } }) => fontSizes.small};
  font-weight: 600;

  max-width: 100%;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    padding: 20px 16px;
    gap: 16px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
  }

  @media (max-width: 768px) {
    padding: 16px 12px;
    flex-wrap: wrap;
    justify-content: center;
    row-gap: 8px;
  }
`;

export const MenuIcon = styled(components.Menu)`
  display: none;
  position: relative;

  cursor: pointer;
  top: 3px;

  fill: ${({ theme: { colors } }) => colors.primary} !important;
  /* @media (max-width: 700px) {
    display: block;
  } */
`;

const LogoImage = styled.img`
  align-self: center;
  width: 131px;

  @media (max-width: 1024px) {
    width: 120px;
  }

  @media (max-width: 768px) {
    width: 110px;
  }
`;

export const Logo = (
  props: ImgHTMLAttributes<HTMLImageElement>,
): JSX.Element => {
  return React.createElement(LogoImage, props);
};

export const UserInfo = styled.div`
  flex: 1;
  text-align: center;
  min-width: 0;

  @media (max-width: 1024px) {
    text-align: center;
  }

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

type LogoutButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

export const Logout = styled.button<LogoutButtonProps>`
  color: ${({ theme: { colors } }) => colors.primary};
  cursor: pointer;
  border: 1px solid #eee;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: ${({ theme: { fontSizes } }) => fontSizes.small};

  &:hover {
    text-decoration: underline;
    background-color: rgba(238, 238, 238, 0.3);
  }

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const WrapperButtons = styled.div`
  display: flex;

  justify-content: space-between;
  align-items: center;

  ${Logout} {
    margin-left: 40px;
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
    ${Logout} {
      margin-left: 16px;
    }
  }

  /* @media (max-width: 700px) {
    display: none;
    width: 0;
  } */
`;

export const WrapperMenu = styled.div`
  /* position: absolute;
  right: 0; */
`;
